import './index.scss'

import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['menu']
  static values = { scrollTo: String }

  connect() {
    if (this.scrollToValue) {
      const item = $(`#${this.scrollToValue}`).find('h2')[0]
      if (item) {
        this.scrollToSelectedElement(item)

        item.classList.add('border-solid', 'border-0', 'border-b-2', 'border-fn-tomato-500')
      }
    }
  }

  toggleOverviewMenu(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle('hidden')
  }

  closeMenu(e) {
    if (!(e.target.classList.contains('shared--overview-menu-toggler')) && !this.menuTarget.classList.contains('hidden')) {
      this.menuTarget.classList.add('hidden')
    }
  }

  hashFromHref(href) {
    const url = new URL(`${window.location.origin}${href}`)

    return url.hash
  }

  scrollToSelectedElement(item) {
    const flyoutContainer = $('.flyout__container')
    const flyoutHeaderHeight = $($('.flyout__header').get()[0]).height()
    const itemPosition = item.getBoundingClientRect().top
    const headerHeight = $(flyoutContainer.find('[data-templates--entity-page--default-target="header"]').get()[0]).height()

    flyoutContainer.get()[0].scrollBy({ top: Math.floor(itemPosition - headerHeight - flyoutHeaderHeight) })

    setTimeout(() => {
      const collapsedHeaderHeight = $(flyoutContainer.find('[data-templates--entity-page--default-target="header"]').get()[0]).height()
      const headerDifference = headerHeight - collapsedHeaderHeight
      if (headerDifference > 0) {
        flyoutContainer.get()[0].scrollBy({ top: headerDifference })
      }
    }, 300)
  }

  scrollToElement(event) {
    const href = this.hashFromHref(event.target.dataset.hrefHash)
    const flyoutContainer = $('.flyout__container')
    const allItems = flyoutContainer.find("h2[data-shared--overview-menu-target='header']").get()
    const item = $(`${href}`).find('h2')[0]

    if (item === undefined) { return }

    this.scrollToSelectedElement(item)

    allItems.forEach(target => $(target)[0].classList.remove('border-solid', 'border-0', 'border-b-2', 'border-fn-tomato-500'))
    item.classList.add('border-solid', 'border-0', 'border-b-2', 'border-fn-tomato-500')
  }
}
